import axios from 'axios'
import appRouter from '@/router'
import { SERVICE_URL } from "../../_commons"
import _ from "underscore";

const namespaced = true;

const state = {
  customerName: '',
  vehicleTypeId: -1,
  vehiclePlateTypeId: -1,
  gvwr: undefined,

  allTypes: [],

  registrationFee: undefined,
};

const mutations = {
  setState(state, data) {
    state[data.property] = data.value; 
  },
};

const actions = {
  async getEstimate({ commit, state, rootState }) {
    // get quote estimate based on user inputs
    const endpoint = `${SERVICE_URL}registration/cost`;

    axios.get(endpoint, { params: {
        vehicleTypeId: state.vehicleTypeId,
        plateTypeId: state.vehiclePlateTypeId,
        lastName: state.customerName,
        GVWR: state.gvwr,
      }})
      .then(result => {
        commit('setState', { property: 'registrationFee', value: result.data.registrationFee });

        // to play it safe - on to next screen IFF 200
        if (result.status === rootState.STATUSES.SUCCESS) {
          appRouter.push({ name: 'QuoteEstimate' });
        }
      })
      .catch(error => {
        console.error(error);
      });
  },

  getVehicleAndPlateTypes({ commit }) {
    // list of vehicle types + plate types
    const endpoint = `${SERVICE_URL}lookup/vehicletypeplatetypemapping`;

    axios.get(endpoint)
      .then(response => {
        commit('setState', { property: 'allTypes', value: response.data});
      })
      .catch(error => {
        console.error(error);
      });
  },

  /**
   * Updates a property of this (quote) module.
   * @param commit
   * @param data { property, value }
   */
  setQuoteData({ commit }, data) {
    // save user inputs
    _.mapObject(data, (val, key) => {
      commit('setState', { property: key, value: val });
    });
  },
};

const getters = {
  estimateInfo: state => ({
    customerName: state.customerName,
    gvwr: state.gvwr,
    vehicleTypeId: state.vehicleTypeId,
    vehiclePlateTypeId: state.vehiclePlateTypeId,
    registrationFee: state.registrationFee,
  }),
  lookupInfo: state => ({
    allTypes: state.allTypes
  }),
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
}
